import React, { useState, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { nanoid } from "nanoid"

import { HiOutlineArrowNarrowLeft } from "react-icons/hi"
import { BiDish } from "react-icons/bi"
import { AiOutlineClockCircle } from "react-icons/ai"
import Steps from "../../components/favRecipes/Steps"

function FavoriteDetailPage({ data }) {
    const history = useHistory()
    const location = useLocation()
    const [ showWine, setShowWine ] = useState( false )

    useEffect(() => {
        const checkRoute = () => {
            if ( location.pathname.includes("/favorite/recipe") ) {
                setShowWine( false )
            } else if ( location.pathname.includes("/favorite/wine") ) {
                setShowWine( true )
            }
        }

        checkRoute()
    }, [location.pathname])

    const handleRouting = () => {
        history.push( "/favorite" )
    }

    return (
        <section>
            <button className="goBackBtn" onClick={handleRouting}><HiOutlineArrowNarrowLeft size="20px" /></button>
            {
                showWine
                    ?   data?.map( item => {
                        return  <article key={nanoid()} className="winePage">
                            <h2>{item.title}</h2>
                            <img src={item.imageURL} alt="Favorite Wine" />
                            <p>{item.description}</p>
                        </article>
                    })
                    :   data?.map( item => {
                        return  <article key={nanoid()} className="recipePage">
                            <header>
                                <section>
                                    <h2>{item.title}</h2>
                                    <div className="diets">
                                        <span className={item.veryHealthy ? "details active" : "details"}>Healthy</span>
                                        <span className={item.vegetarian ? "details active" : "details"}>Vegetarian</span>
                                        <span className={item.vegan ? "details active" : "details"}>Vegan</span>
                                        <span className={item.glutenFree ? "details active" : "details"}>Gluten Free</span>
                                        <span className={item.dairyFree ? "details active" : "details"}>Dairy Free</span>
                                    </div>
                                    <div>
                                        <BiDish size="22px" /> 
                                        <p>{item.servings} servings</p>
                                    </div>
                                    <div>
                                        <AiOutlineClockCircle size="20px" /> 
                                        <p>{item.readyInMinutes} minutes</p>
                                    </div>
                                </section>
                                <img src={item.image ? item.image : item.imageURL} alt="Favorite Recipe" />
                            </header>
    
                            <div className="summary">
                                <p>{item?.summary?.replace(/<\/?[^>]+>/gi, "")}</p>
                            </div>
    
                                    
                            {/* <Ingredients ingredients={item.ingredients} setOtherIngredients={setOtherIngredients} /> */}
                                    
                            { item.analyzedInstructions?.map( instruction => <Steps steps={instruction.steps} key={nanoid()} /> )}
                        </article>
                    })
            }
        </section>
    )
}

export default FavoriteDetailPage
